import React from "react"; 
import { Link } from "react-router-dom";    
import CreateProductTypeForm from "./CreateProductTypeForm";

const CreateProductType = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Create Product Type</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>eCommerce</li>
          <li>Create Product Type</li>
        </ul>
      </div> */}

      <CreateProductTypeForm />
    </>
  );
};

export default CreateProductType;
